import React from 'react';
import { PageHeader } from '../components/ui/PageHeader';
import { Card, CardContent } from '../components/ui/Card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/Accordion';
import { ContactCTA } from '../components/ContactCTA';
import { StructuredData } from '../components/StructuredData';
import { useSeo } from '../hooks/useSeo';
import { FAQ as FAQ_ITEMS, FaqItem } from '../data/faq';
const CATEGORIES: FaqItem['category'][] = ['Candidats', 'Formation', 'Financement', 'Entreprises'];
export function FAQ() {
  useSeo({
    title: "Questions fréquentes sur l'alternance",
    description: "Inscription, âge limite, rentrée, coût, salaire d'apprenti, aides pour les entreprises : toutes les réponses sur l'alternance chez Zillenium Alternance, CFA à Joigny dans l'Yonne.",
    path: '/faq'
  });
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: FAQ_ITEMS.map(item => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer
      }
    }))
  };
  return <div className="flex flex-col w-full" data-id="element-1669" data-mp="1uhnfd6c106sx">
      <StructuredData id="faq" data={faqSchema} data-id="element-1670" data-mp="1zdvq87j6xdua" />

      <PageHeader title="Questions fréquentes" subtitle="Les réponses aux questions que se posent le plus souvent les candidats, les familles et les entreprises." data-id="element-1671" data-mp="1zh9ujlbezx4d" />

      <div className="py-16 md:py-24 bg-muted relative overflow-hidden" data-id="element-1672" data-mp="29b0fig8c1pfb">
        <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary rounded-full blur-[120px] opacity-10 pointer-events-none" data-id="element-1673" data-mp="2dddhqunvf57c" />
        <div className="container max-w-4xl mx-auto relative z-10 space-y-10" data-id="element-1674" data-mp="2i7r8ukvi2q67">
          {CATEGORIES.map(category => {
          const items = FAQ_ITEMS.filter(i => i.category === category);
          if (items.length === 0) return null;
          return <Card key={category} className="border-none shadow-lg bg-white overflow-hidden" data-id="element-1675" data-mp="2x373os3wmq3n">
                <div className="h-2 w-full bg-brand-orange" data-id="element-1676" data-mp="22fp4tju3sks1" />
                <CardContent className="p-6 md:p-10" data-id="element-1677" data-mp="22ha05bo8s7qy">
                  <h2 className="text-2xl font-extrabold font-heading text-primary-dark mb-6" data-id="element-1678" data-mp="2h4uy6r69fgs0">
                    {category}
                  </h2>
                  <Accordion type="single" collapsible className="w-full" data-id="element-1679" data-mp="2ccbkzvbhinnq">
                    {items.map((item, i) => <AccordionItem key={item.question} value={`${category}-${i}`} data-id="element-1680" data-mp="2l5yfli3yhkvc" data-mpi={i}>
                        <AccordionTrigger className="text-left font-bold text-primary-dark hover:text-primary" data-id="element-1681" data-mp="302p7l6bavuax">
                          {item.question}
                        </AccordionTrigger>
                        <AccordionContent className="text-muted-foreground leading-relaxed text-base" data-id="element-1682" data-mp="15ppxfspovsb1">
                          {item.answer}
                        </AccordionContent>
                      </AccordionItem>)}
                  </Accordion>
                </CardContent>
              </Card>;
        })}

          <ContactCTA title="Votre question n'est pas dans la liste ?" subtitle="Appelez-nous ou écrivez-nous sur WhatsApp : nous répondons directement, sans passer par un formulaire." data-id="element-1683" data-mp="32nna8xot5ylz" />
        </div>
      </div>
    </div>;
}